import { Button } from '@/components/shadcn/ui/button';
import { Calendar } from '@/components/shadcn/ui/calendar';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/shadcn/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/ui/select';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { useBusinessDetailContext } from '@/context/BusinessDetailContext';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { CalendarIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm, useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { z } from 'zod';
import { useBusiness } from '@/hook/useBusiness';
import { toast } from '@/components/shadcn/ui/use-toast';
import { useProductWithBusiness } from '@/hook/useProductWithBusiness';
const Situation = () => {
  const { control, getValues, setValue } = useFormContext();
  const { leadId } = useParams<{ leadId: string }>();
  const leadId2Set = Number(leadId);
  const navigate = useNavigate();
  const { business, businessEdit, setBusinessEdit, businessEdit2, setBusinessEdit2 } = useBusinessDetailContext();
  const { updateBusiness, aproveBusiness, cancelBusiness, declineBusiness } = useBusiness();
  const { productsWithBusiness } = useProductWithBusiness();


  const handleSubmit = () => {
    if (businessEdit2.situacao === 'Cancelada') {
      cancelBusiness(leadId2Set, {
        reason: businessEdit2.motivo
      });

      navigate("/kanban");
      toast({
        title: 'Negócio Cancelado com sucesso'
      });

    } if (businessEdit2.situacao === 'Aprovada') {
      aproveBusiness(leadId2Set, { closedAt: businessEdit2.dtfechamento });
      navigate("/kanban");
      toast({
        title: 'Negócio Aprovado com sucesso'
      });

    } else if (businessEdit2.situacao === 'Declinado') {
      declineBusiness(leadId2Set, {
        reason: businessEdit2.motivo
      });

      navigate("/kanban");
      toast({
        title: 'Negócio Declinado com sucesso'
      });

    }
  };
if (!businessEdit2) {
  return <div className="flex justify-center items-center h-screen">Carregando...</div>;
}

  return (
    <div className='flex justify-center h-screen w-screen' >
      <form className='flex flex-col gap-4 py-2 px-2 rounded-xl items-start h-auto max-h-max w-[30%] bg-white'>

        {/** Situação */}
        <FormField
          control={control}
          name='situacao'
          render={({ field }) => (
            <FormItem className='w-full'>
              <FormLabel className='text-slate-900 w-full'>Situação</FormLabel>
              <Select defaultValue={businessEdit2.situacao} onValueChange={(value) => {
                field.onChange(value);
                setValue('situacao', value);
                setBusinessEdit2(getValues());
              }}>
                <FormControl>
                  <SelectTrigger className='bg-slate-50 hover:bg-slate-100 hover:text-slate-900 focus:bg-white text-muted-foreground'>
                    <SelectValue />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Aberto">Aberto</SelectItem>
                  {productsWithBusiness.length > 0 && (<SelectItem value="Cancelada">Cancelada</SelectItem>)}
                  {productsWithBusiness.length > 0 && (<SelectItem value="Aprovada">Aprovada</SelectItem>)}
                  {productsWithBusiness.length == 0 && (<SelectItem value="Declinado">Declinado</SelectItem>)}
                </SelectContent>
              </Select>
            </FormItem>
          )}
        />

        {businessEdit2.situacao === 'Cancelada' && (
          <FormField
            control={control}
            name='motivo'
            render={({ field }) => (
              <FormItem>
                <FormLabel className='text-slate-900'>Motivo</FormLabel>
                <Textarea
                  {...field}
                  defaultValue={businessEdit2.motivo !== '' ? businessEdit2.motivo : ''}
                  placeholder='Informe o motivo'
                  className='bg-slate-50 text-muted-foreground hover:bg-slate-100 focus:bg-white'
                  onChange={(e) => {
                    // Atualizando o valor no formulário
                    setValue('motivo', e.target.value);
                    setBusinessEdit2(getValues()); // Para exibir no console o valor enquanto digita
                  }}
                />
              </FormItem>
            )}
          />
        )}

        {businessEdit2.situacao === 'Declinado' && (
          <FormField
            control={control}
            name='motivo'
            render={({ field }) => (
              <FormItem>
                <FormLabel className='text-slate-900'>Motivo</FormLabel>
                <Textarea
                  {...field}
                  defaultValue={businessEdit2.motivo !== '' ? businessEdit2.motivo : ''}
                  placeholder='Informe o motivo'
                  className='bg-slate-50 text-muted-foreground hover:bg-slate-100 focus:bg-white'
                  onChange={(e) => {
                    // Atualizando o valor no formulário
                    setValue('motivo', e.target.value);
                    setBusinessEdit2(getValues()); // Para exibir no console o valor enquanto digita
                  }}
                />
              </FormItem>
            )}
          />
        )}

        {businessEdit2.situacao === 'Aprovada' && (
          <FormField
            control={control}
            name='dtfechamento'
            render={({ field }) => (
              <FormItem>
                <FormLabel className='text-slate-900 w-full pb-2.5'>Data Fechamento</FormLabel>
                <Popover>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant={'outline'}
                        className={cn(
                          'w-full pl-3 text-left font-normal bg-slate-50 focus:bg-white text-muted-foreground',
                          !field.value && 'text-muted-foreground'
                        )}
                      >
                        {field.value ? (
                          format(field.value, 'PPP', { locale: ptBR })
                        ) : (
                          <span>Escolha uma data</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={field.value}
                      onSelect={(date) => {
                        console.log("Data selecionada:", date); // Debug
                        if (date) {
                          field.onChange(date);
                          setValue('dtfechamento', date);
                          setBusinessEdit2(getValues()); // Garante atualização no contexto
                        }
                      }}
                      initialFocus
                      locale={ptBR}
                    />
                  </PopoverContent>
                </Popover>
              </FormItem>
            )}
          />
        )}
        <Button type="button" onClick={handleSubmit} className='mt-2 w-1/3 self-end'>
          Salvar Alterações
        </Button>
      </form>
    </div>
  );
};

export default Situation;
